__turbopack_context__.v({
  "className": "caveat_6cd3196c-module__EPWM7a__className",
});
